var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "en",
      staticStyle: { height: "100%" },
      attrs: { id: "i18n" }
    },
    [
      _vm.browserSupport == false
        ? _c("div", { staticClass: "browser" }, [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://www.google.cn/intl/zh-CN/chrome/"
                }
              },
              [_vm._v(_vm._s(_vm.$t("broswer1")))]
            ),
            _vm._v(" \n\n    "),
            _c("i", {
              staticClass: "el-icon-close",
              staticStyle: {
                cursor: "pointer",
                "margin-left": "10px",
                "font-size": "16px",
                "vertical-align": "middle"
              },
              on: { click: _vm.noSign }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app11", attrs: { id: "box" } }, [
        _c("div", { staticClass: "topbar" }, [
          _c("i", { on: { click: _vm.goHome } }),
          _vm._v(" "),
          _c("div", { staticClass: "mainBox1" }, [
            _c(
              "div",
              {
                staticClass: "changeLangBtn",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.moreLang()
                  }
                }
              },
              [
                _c("button", { staticClass: "text" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("language")) + "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("em", { staticClass: "iconfont icon-een" }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.changeLangBox,
                        expression: "changeLangBox"
                      }
                    ],
                    staticClass: "chooseLangUl"
                  },
                  _vm._l(_vm.langList, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "chooseLangUlli",
                        on: {
                          click: function($event) {
                            _vm.setLanguage(item.id)
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  })
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "banner" }, [
          _c("div", { staticClass: "loginOrres" }, [
            _c("button", { staticClass: "login", on: { click: _vm.login } }, [
              _vm._v(_vm._s(_vm.$t("homepage_button1")))
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "res", on: { click: _vm.resg } }, [
              _vm._v(_vm._s(_vm.$t("homepage_button2")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.padWarnShow
        ? _c("div", { staticClass: "bgiOver" }, [
            _c("div", { staticClass: "over over1" }, [
              _c("div", {
                staticClass: "timeout032",
                on: { click: _vm.getOut }
              })
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eaf803a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eaf803a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/join.vue
// module id = null
// module chunks = 